import type { MotDuPasteur } from '@/types/Contenu'

// Mot du pasteur — valeur initiale, modifiable depuis /admin.
// TODO: remplacer la vidéo de prévisualisation par le vrai message vidéo du pasteur.
export const MOT_DU_PASTEUR_INITIAL: MotDuPasteur = {
  nom: 'Timothée MBENGELA',
  fonction: 'Pasteur principal',
  // Fichier servi depuis public/images (chemin stable, identique à celui enregistré en base).
  photo: '/images/main_pastor.png',
  texte: `Cher visiteur, chère visiteuse,

C'est avec une joie profonde que je vous accueille, que ce soit à travers cet écran ou bientôt en personne, un dimanche.

Le Centre Missionnaire Philadelphie n'est pas né d'une ambition humaine, mais d'un appel : rassembler une famille où chacun peut rencontrer Dieu et grandir, sans jugement ni pression. J'ai vu, au fil des années, des vies transformées ici — des personnes qui sont arrivées brisées et reparties porteuses d'espérance. C'est ce que je souhaite pour vous aussi.

Notre église n'est pas parfaite, et nous ne prétendons pas l'être. Mais nous croyons en un Dieu qui l'est, et qui aime nous rencontrer là où nous en sommes. Que vous portiez des questions, des doutes ou simplement de la curiosité, vous êtes le bienvenu chez nous.

Mon rôle, avec toute l'équipe pastorale, est de vous accompagner : par l'enseignement de la Parole, par la prière, et par une présence sincère à vos côtés. Nous ne cherchons pas à remplir une salle, mais à voir des vies changées et des familles restaurées.

Si c'est votre première fois, sachez que vous n'avez rien à prouver ici. Venez comme vous êtes. Et si vous cherchez une famille spirituelle depuis longtemps, peut-être est-ce ici que votre recherche s'arrête.

**Au nom de toute l'église, soyez béni.**
**Pasteur Timothée MBENGELA**`,
}
